export const STANDARD_TOAST_POSITION_CLASS = '-translate-x-1/2 fixed top-[72px] left-1/2';

/** 直播配置限流提示在所有端都显示在屏幕正中。 */
export const STANDARD_TOAST_H5_CENTER_POSITION_CLASS = '-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2';

export const STANDARD_TOAST_CLASS =
  'w-fit rounded-[100px] border-none bg-[#2E2F33] px-6 py-4 font-semibold text-sm text-white shadow-none backdrop-blur-[20px]';

export const STANDARD_TOAST_TEXT_CLASS = 'font-semibold text-sm text-white leading-5 opacity-100';

/**
 * 直播配置限流提示。
 * w-max 按整句宽度撑开，max-w 限制在屏幕两侧各 16px。
 * 不要用 sm:w-[calc(100vw-32px)]：短中文会被拉满。不要用 w-fit：长英文换行会收到单词宽。
 */
export const LIVE_TOAST_CLASS =
  'w-max max-w-[calc(100vw-32px)] rounded-16 border-none bg-[rgba(42,42,42,0.6)] px-4 py-3 font-medium text-xs text-white shadow-none backdrop-blur-none [&>div]:min-w-0';
export const LIVE_TOAST_TEXT_CLASS = 'min-w-0 break-words font-medium text-xs text-white leading-[18px] opacity-100';
